import api from './api';

const listProgramMentors = ({ organizationId, programId, ...query }) =>
  api.get(`/api/organizations/${organizationId}/programs/${programId}/mentors/`, { params: query });

export default {
  listProgramMentors,
};
